export default {"src":"/trader-new/_next/static/media/Team.8f759028.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};